import React, { useEffect } from 'react';
import Modal, { ModalFooter, ModalHeader, Prompt } from '@ingka/modal';

import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/focus/dist/style.css';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useIntl } from 'react-intl';
import Body from 'ui/Typography/Body';
import { useSelector } from 'react-redux';
import {
  hideCantOpenDesignModal,
  isCantOpenDesignModalVisible,
  setLoadVpcSheetVisible,
  showCantOpenDesignModal
} from 'ducks/sheets';
import { useAppDispatch } from 'ducks/hooks';
import { AppRoutes } from 'routes';
import { useHistory } from 'react-router-dom';
import { reportDesignErrorScreen } from 'analytics/reporters';
import { useCore } from 'contexts/core';
import Button from '@ingka/button';
import { useSceneHandler } from 'contexts/sceneHandler';

function CantOpenDesignModal() {
  const isVisible = useSelector(isCantOpenDesignModalVisible);
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const coreApi = useCore();
  const { clearLocalScene } = useSceneHandler();

  const onGoToInspiration = () => {
    dispatch(hideCantOpenDesignModal());
    history.push(AppRoutes.LANDING_PAGE);
  };

  const onStartFromScratch = () => {
    dispatch(hideCantOpenDesignModal());
    clearLocalScene();
    history.replace(AppRoutes.PLANNER_NEW);
  };

  useEffect(() => {
    if (isVisible) {
      dispatch(setLoadVpcSheetVisible(false));
    }
  }, [dispatch, isVisible]);

  useEffect(() => {
    const onVpcLoadFailed = (vpcCode: string | undefined) => {
      dispatch(showCantOpenDesignModal());
      reportDesignErrorScreen({ vpcCode: vpcCode ? vpcCode : undefined });
    };
    return coreApi.subscribe('loadVpcFailure', vpcCode => onVpcLoadFailed(vpcCode));
  }, [coreApi, dispatch]);

  return (
    <Modal
      id="vpc-error-modal"
      data-testid="vpc-error-modal"
      visible={isVisible}
      escapable={true}
      handleCloseBtn={() => dispatch(hideCantOpenDesignModal())}
      style={{ zIndex: 2000 }}
    >
      <Prompt
        aria-labelledby="CantOpenDesignPrompt"
        title={formatMessage({ id: 'storageone.cantOpenDesignModalTitle' })}
        titleId="CantOpenDesignPrompt"
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={
          <ModalFooter>
            <Button
              text={formatMessage({ id: 'storageone.cantOpenDesignModalPrimaryButton' })}
              onClick={onGoToInspiration}
              type="secondary"
              data-testid="open-gallery"
            ></Button>
            <Button
              text={formatMessage({ id: 'storageone.cantOpenDesignModalSecondaryButton' })}
              onClick={onStartFromScratch}
              type="primary"
            ></Button>
          </ModalFooter>
        }
      >
        <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
          {formatMessage({ id: 'storageone.cantOpenDesignModalBody' })}
        </Body>
      </Prompt>
    </Modal>
  );
}

export default CantOpenDesignModal;
